export class PaymentContext {
    public paymentMethod: string = ""
    public isAnonymous: boolean = false
    constructor(isAnonymous: boolean = false) {
        this.isAnonymous = isAnonymous
    }
}